import types from './types';

const Reducer = (state, action) => {
  switch (action.type) {
    case types.SET_OVERLAY:
      return {
        ...state,
        overlay: action.payload
      };

    case types.SET_ACTIVE_ACCOUNT:
      return {
        ...state,
        activeAccount: action.payload
      };

    case types.SWITCH_ACCOUNT:
      return {
        ...state,
        activeAccount: action.payload,
        switchingAccount: true
      };

    case types.SWITCHED_ACCOUNT:
      return {
        ...state,
        switchingAccount: false
      };

    case types.SET_IS_ADMIN:
      return {
        ...state,
        userIsAdmin: action.payload
      };

    case types.SET_NAV_REF:
      return {
        ...state,
        navRef: action.payload
      };

    case types.SET_MENU_REF:
      return {
        ...state,
        menuRef: action.payload
      };

    case types.SET_NAV_TOGGLE_REF:
      return {
        ...state,
        navToggleRef: action.payload
      };

    case types.SET_MENU_TOGGLE_REF:
      return {
        ...state,
        menuToggleRef: action.payload
      };

    case types.SET_PUSH_NOTIFICATION:
      return {
        ...state,
        pushNotification: action.payload
      };

    default:
      return state;
  }
};

export default Reducer;
